import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "../../store/store";

interface ProtectedRouteProps {
	children: ReactNode;
	requiredRoles?: string[];
}

function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
	const location = useLocation();
	const { isAuthenticated, user } = useSelector(
		(state: RootState) => state.auth
	);

	if (!isAuthenticated) {
		// Store current path before redirecting to login
		if (location.pathname !== "/login") {
			localStorage.setItem("redirectPath", location.pathname);
		}

		return (
			<Navigate
				to="/login"
				replace
			/>
		);
	}

	if (requiredRoles && user && !requiredRoles.includes(user.role)) {
		return (
			<Navigate
				to="/dashboard"
				replace
			/>
		);
	}

	return <>{children}</>;
}

export default ProtectedRoute;
